import {get, post, put, _delete} from "../utils/http.ts";
import {BASE_URL} from "./index.ts";
import {NoteType, SetDefaultNoteTypeBody, CreateNoteTypeBody, UpdateNoteTypeBody} from "../utils/types.ts";

export async function getNoteTypes(): Promise<NoteType[]> {
  return get<NoteType[]>(new URL(`${BASE_URL}/note_types`));
}

export async function getNote(noteId: number): Promise<NoteType> {
  if(!noteId) throw new Error('Note ID is required');
  return get<NoteType>(new URL(`${BASE_URL}/notes/${noteId}`));
}

export async function setDefaultNoteType(noteTypeId: number): Promise<void> {
  if(!noteTypeId) throw new Error('Note type ID is required');
  const body: SetDefaultNoteTypeBody = { note_type_id: noteTypeId };
  return put(new URL(`${BASE_URL}/note_types/default`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function getDefaultFollowupNoteType(): Promise<NoteType | null> {
  return get<NoteType | null>(new URL(`${BASE_URL}/note_types/default_followup`));
}

export async function setDefaultFollowupNoteType(noteTypeId: number | null): Promise<void> {
  const body: SetDefaultNoteTypeBody = { note_type_id: noteTypeId };
  return put(new URL(`${BASE_URL}/note_types/default_followup`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function createNoteType(body: CreateNoteTypeBody): Promise<NoteType> {
  if(!body.name) throw new Error('Note type name is required');
  return post<NoteType>(new URL(`${BASE_URL}/note_types`), { body });
}

export async function updateNoteType(noteTypeId: number, body: UpdateNoteTypeBody): Promise<NoteType> {
  if(!noteTypeId) throw new Error('Note type ID is required');
  return put<NoteType>(new URL(`${BASE_URL}/note_types/${noteTypeId}`), { body });
}

export async function archiveNoteType(noteTypeId: number): Promise<void> {
  if(!noteTypeId) throw new Error('Note type ID is required');
  return _delete(new URL(`${BASE_URL}/note_types/${noteTypeId}`));
}